import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M26.73 24.33V7.387a2.118 2.118 0 1 0-4.236 0V24.33a2.118 2.118 0 1 0 4.235 0M24.611 4a3.39 3.39 0 0 0-3.388 3.388V24.33a3.388 3.388 0 0 0 6.776 0V7.39A3.39 3.39 0 0 0 24.612 4M9.506 24.33v-8.471a2.118 2.118 0 0 0-4.235 0v8.47a2.118 2.118 0 1 0 4.235 0M7.388 12.47A3.39 3.39 0 0 0 4 15.86v8.47a3.388 3.388 0 1 0 6.777 0v-8.47a3.39 3.39 0 0 0-3.389-3.388m10.589 8.471v3.388a2.118 2.118 0 1 1-4.236 0v-3.388a2.118 2.118 0 1 1 4.236 0m-5.506 0a3.388 3.388 0 1 1 6.776 0v3.388a3.388 3.388 0 0 1-6.776 0z",
      clipRule: "evenodd"
    }
  )
);
var SvgMonitoringOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MonitoringOutlined_default = SvgMonitoringOutlined;

export { MonitoringOutlined_default as default };
